import { useRouter } from "next/router";
import * as React from "react";
import { useTranslation } from "react-i18next";

import { CalendarMonthTwoTone } from "@/components/icons/calendar-month-two-tone";
import SyncedListNotice from "@/components/import-list/synced-list-notice-component";

type ScheduleSettingsType = {
  type: "default" | "embedded" | "synced";
  minimal?: boolean;
};

export default function ScheduleSettings({
  minimal = false,
  type,
}: ScheduleSettingsType) {
  const { t } = useTranslation();
  const { query } = useRouter();
  const slug = query.slug as string;

  const title =
    type === "default"
      ? t("preference-panel.block-display-name.defaultschedule")
      : type === "embedded"
      ? t("preference-panel.block-display-name.embeddedschedule")
      : t("preference-panel.block-display-name.schedule-synced");

  return (
    <SyncedListNotice
      title={title}
      icon={CalendarMonthTwoTone}
      path="schedules"
      eventSlug={slug}
      minimal={minimal}
    >
      {t("preference-panel.schedule.embedded-schedule-synced")}
    </SyncedListNotice>
  );
}
